import { MessageSquare } from 'lucide-react';
import { cn } from '../../utils/cn';
import styles from './NotesBadge.module.css';

interface NotesBadgeProps {
  count: number;
  onClick: (e: React.MouseEvent) => void;
}

export function NotesBadge({ count, onClick }: NotesBadgeProps) {
  return (
    <button
      type="button"
      className={cn(styles.btn, count > 0 && styles.active)}
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      aria-label={count > 0 ? `${count} staff note${count !== 1 ? 's' : ''}` : 'Add staff note'}
      title={count > 0 ? `${count} staff note${count !== 1 ? 's' : ''}` : 'Add staff note'}
    >
      <MessageSquare size={15} aria-hidden />
      {count > 0 && <span className={styles.count}>{count}</span>}
    </button>
  );
}
